<script setup lang="ts">
  import type { IMenuItem } from '@/components/sidebar-menu/types'
  import { useLocaleStore } from '@/stores/Locale.store'

  const localeStore = useLocaleStore()

  const { locale } = useI18n()
  const { currentRoute } = useRouter()

  const props = defineProps<{
    blok: any
    showMobile?: boolean
    showDesktop?: boolean
  }>()

  const translatedRoute = (url: string) => {
    return '/' + locale.value + '/' + url
  }

  const menuItems = computed<IMenuItem[]>(() => {
    return props.blok.items.reduce((menuItem: IMenuItem[], item: any) => {
      if (typeof item === 'string') return menuItem

      if (
        item?.content?.whitelistCountries?.length &&
        !item?.content?.whitelistCountries.includes(localeStore.selectedCountry)
      ) {
        return menuItem
      }

      const isActive =
        currentRoute.value.path === item.content.href.url ||
        currentRoute.value.path === translatedRoute(item.content.href.cached_url)

      menuItem.push({
        name: item.content.text,
        href: item.content.href.url || translatedRoute(item.content.href.cached_url),
        active: isActive
      })

      return menuItem
    }, [])
  })
</script>

<template>
  <div v-editable="blok">
    <SidebarMenuMobile
      v-if="showMobile"
      :menu-items="menuItems"
    />
    <SidebarMenuDesktop
      v-if="showDesktop"
      :menu-items="menuItems"
    />
  </div>
</template>
